<template>
<div class="information" id="informationBox">
    <ul class="top" id="top" :style="{color:topColor}">
        <li v-for="item in informationListTop">
            [置顶]
            <i v-if="showTime">{{getDate(item.createTime)}}</i>
            <span v-if="item.showContent=='Y'"><a href="javascript:void(0)" @click="clickTitle(item.id)" :style="{color:topColor}">{{item.title}}</a></span>
            <span v-else>{{item.title}}</span>
        </li>
    </ul>
    <div ref="information" class="not-top" :style="{height:height+'px'}">
        <ul ref="information1" id="information1">
            <li v-for="item in informationListElse">
                <i v-if="showTime">{{getDate(item.createTime)}}</i>
                <span v-if="item.showContent=='Y'"><a href="javascript:void(0)" @click="clickTitle(item.id)">{{item.title}}</a></span>
                <span v-else>{{item.title}}</span>
            </li>
        </ul>
        <ul ref="information2" v-if="showDB">
            <li v-for="item in informationListElse">
                <i v-if="showTime">{{getDate(item.createTime)}}</i>
                <span v-if="item.showContent=='Y'"><a href="javascript:void(0)" @click="clickTitle(item.id)">{{item.title}}</a></span>
                <span v-else>{{item.title}}</span>
            </li>
        </ul>
    </div>
    <information-issue-view ref="showInformation"></information-issue-view>
</div>
</template>
<script>
import Util from '@/libs/util.js'
import { formatDate } from './information_public.js'
import informationIssueView from './information_issue_view.vue'
export default {
  name: 'ctsiInformationIssue',
  props: { showTime: { default: true }, limitNum: { default: 10 }, requestInterval: { default: 15 }, speed: { default: 50 }, topColor: { default: '#f00' }, showDetail: { default: false }, dateFormat: { default: 'yyyy-MM-dd HH:mm:ss' } },
  components: { informationIssueView },
  data () {
    return {
      informationList: [],
      timer: null,
      height: 0,
      showDB: false,
      requestTimer: null
    }
  },
  computed: {
    informationListTop () {
      return this.informationList.filter(item => { return item.istop == 1 })
    },
    informationListElse () {
      return this.informationList.filter(item => { return item.istop == 0 })
    }
  },
  methods: {
    init () {
      let self = this
      Util.http.get('/api/system/cscpInformationIssuesList', { params: { limitNum: this.limitNum } }).then(function (response) {
        self.informationList = response.data.data
        setTimeout(() => {
          let _padding = document.getElementById('informationBox').style.paddingLeft.replace('px', '') * 1 + document.getElementById('informationBox').style.paddingRight.replace('px', '') * 1
          self.height = document.getElementById('informationBox').clientHeight - _padding - document.getElementById('top').clientHeight
          if (document.getElementById('information1').clientHeight > self.height) {
            self.showDB = true
            self.gundong()
          }
        }, 200)
      }).catch(function (error) {
        console.log(error)
      })
    },
    clickTitle (id) {
      let self = this
      Util.http.get(`/api/system/cscpInformationIssues/${id}`).then(response => {
        self.$emit('on-click', response.data)
        if (self.showDetail) {
          self.$refs.showInformation.showModel(response.data)
        }
      }).catch(error => {
        if (error.response.data.message) {
          self.$Notice.error({ title: '提示', desc: error.response.data.message })
        }
      })
    },
    // 转时间
    getDate (time) {
      let aaa = formatDate(time, this.dateFormat)
      return aaa
    },
    gundong () {
      let _this = this
      let speed = this.speed
      if (this.timer) {
        clearInterval(this.timer)
      }
      this.timer = setInterval(_this.Marquee, speed)
      this.$refs.information.onmouseenter = function () {
        clearInterval(_this.timer)
      }
      this.$refs.information.onmouseleave = function () {
        if (_this.timer) {
          clearInterval(_this.timer)
        }
        _this.timer = setInterval(_this.Marquee, speed)
      }
    },
    Marquee () {
      let _information = this.$refs.information
      let _information1 = this.$refs.information1
      let _information2 = this.$refs.information2
      if (_information2.offsetTop - _information.scrollTop <= 0) {
        _information.scrollTop -= _information1.offsetHeight
      } else {
        _information.scrollTop++
      }
    }
  },
  mounted () {
    this.init()
    let _this = this
    this.requestTimer = setInterval(_this.init, this.requestInterval * 1000)
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer)
    }
    if (this.requestTimer) {
      clearInterval(this.requestTimer)
    }
  }
}
</script>
<style scoped lang="less">
.information{width: 100%;height: 100%;overflow: hidden;color: #333;
    .not-top{position: relative;overflow: hidden;}
    li{padding:5px 0;line-height: 24px;font-size: 14px;list-style-type: none;
        i{padding-right: 5px;font-style: normal;}
        a{text-decoration: underline;color: #333;}
    }
}
</style>
